module.exports = __webpack_public_path__ + "img/489c385.jpg";